<template>
  <div class="hb-tabs" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      role="tab"
      class="hb-tabs__tab"
      :class="{ 'hb-tabs__tab--active': tab.key === value }"
      :aria-selected="tab.key === value ? 'true' : 'false'"
      @click="select(tab.key)"
    >
      {{ tab.label }}
      <span v-if="tab.count !== undefined && tab.count !== null" class="hb-tabs__count">{{ tab.count }}</span>
    </button>
  </div>
</template>

<script>
/**
 * Abas sublinhadas do painel.
 *
 * Nao usa `b-tabs`: o tema restila `.nav-pills`/`.nav-tabs` com preenchimento solido e
 * glow primario (@core/scss/base/bootstrap-extended/_nav.scss), e desfazer isso custa mais
 * CSS do que o controle inteiro. Alem disso `b-tabs` exige que os paineis sejam `<b-tab>`
 * filhos, o que atrapalha estado de carregamento e de erro por painel.
 */
export default {
  name: 'HbTabs',
  props: {
    value: { type: String, required: true },
    /** [{ key, label, count? }] */
    tabs: { type: Array, required: true },
  },
  methods: {
    select(key) {
      if (key === this.value) return
      this.$emit('input', key)
    },
  },
}
</script>

<style scoped>
.hb-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  border-bottom: 1px solid var(--border-color);
}

.hb-tabs__tab {
  min-height: 44px;
  padding: 0.7rem 1.1rem;
  margin-bottom: -1px;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-body);
  font-family: var(--font-ui);
  font-size: var(--fs-base);
  font-weight: var(--fw-medium);
  cursor: pointer;
  transition: color var(--dur-fast) var(--ease-in-out);
}

.hb-tabs__tab:hover {
  color: var(--primary);
}

.hb-tabs__tab--active {
  border-bottom-color: var(--primary);
  color: var(--primary);
}

.hb-tabs__count {
  margin-left: 0.35rem;
  font-size: var(--fs-xs);
  color: var(--text-muted);
}

.hb-tabs__tab--active .hb-tabs__count {
  color: var(--primary);
}
</style>
